import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import appDisplay from 'scoreboard/components/app-display'
import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import dependencyConfirmationPrompt from 'scoreboard/components/edit/dependency-confirmation-prompt'
import EditProjectDialog from './edit-project-dialog'
import template from './edit-tree-menu.hbs'

var EditTreeMenu = Backbone.View.extend({

	tagName: 'ul',

	className: 'tree-menu',

	events: {
		'click .edit': 'edit',
		'click .delete': 'delete'
	},

	/**
	 * @param options.gardener the gardener for the main project selector
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function () {
		this.$el.append(template())
		this.secure()
		return this
	},

	secure: function() {
		if (config.replicationInputEnabled) {
			this.$('.edit, .delete').remove()
		}
	},

	edit: function(e) {
		e.stopPropagation() // don't close the project selector
		appDisplay.replaceDialog(new EditProjectDialog({model: this.model}))
	},

	'delete': function(e) {
		e.stopPropagation() // don't close the project selector
		const url = `api/projects/${this.model.id}/delete-dependencies`
		dependencyConfirmationPrompt(url, this.model, info => {
			var list = _.concat(info.copies || [], info.descendants || [])
			const label = this.model.get('label')
			return {
				list,
				message: this._createDeleteMessage(list, info.warning),
				prompt: i18n.get('common.project.delete.prompt', label)
			}
		})
	},

	_createDeleteMessage: function (list, warning) {
		var message = warning
		if (!_.isEmpty(list)) {
			var makeListItem = (html, idLabel) => {
				return html + '<li>' + _.escape(idLabel.label) + '</li>'
			}
			message += `<ul>${_.reduce(list, makeListItem, '')}</ul>`
		}
		return message
	}

})

export default EditTreeMenu

EditTreeMenu.__filename__ = 'projects/edit-tree-menu.js'
